module.exports = __webpack_public_path__ + "img/logo12.ca25098d.png";